import React, { createContext, useContext, useState, useEffect } from 'react';

// Supported languages
export const LANGUAGES = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'pt', name: 'Português', flag: '🇧🇷' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
];

// Translations
const translations = {
    en: {
        // Navigation
        home: 'Home',
        newEntry: 'New Entry',
        entries: 'Entries',
        insights: 'Insights',
        reminders: 'Reminders',
        partners: 'Partners',
        resources: 'Resources',
        settings: 'Settings',
        upgrade: 'Upgrade',
        admin: 'Admin',
        more: 'More',
        signOut: 'Sign Out',
        
        // Auth
        signIn: 'Sign In',
        createAccount: 'Create Account',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        birthday: 'Birthday',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        preferNotToSay: 'Prefer not to say',
        language: 'Preferred Language',
        selectLanguage: 'Select language...',
        alreadyHaveAccount: 'Already have an account?',
        dontHaveAccount: "Don't have an account?",
        receiveEmails: 'Receive mood reminders and tips via email',
        
        // Dashboard
        welcomeBack: 'Welcome back',
        howAreYouFeeling: 'How are you feeling today?',
        yourMoodStreak: 'Your mood streak',
        days: 'days',
        recentEntries: 'Recent Entries',
        viewAll: 'View All',
        noEntriesYet: 'No entries yet',
        startJourney: 'Start your journaling journey',
        
        // New Entry
        createNewEntry: 'Create New Entry',
        moodRating: 'Mood Rating',
        selectEmoji: 'Select an emoji',
        whatSongMatchesMood: 'What song matches your mood?',
        writeYourThoughts: 'Write your thoughts...',
        save: 'Save',
        saving: 'Saving...',
        
        // Partners
        accountabilityPartners: 'Accountability Partners',
        invitePartner: 'Invite Partner',
        sendMoodReport: 'Send Mood Report',
        partnerEmail: "Partner's Email",
        personalMessage: 'Personal Message (optional)',
        sendInvitation: 'Send Invitation',
        myPartners: 'My Partners',
        noPartnersYet: 'No partners yet',
        connected: 'Connected',
        pending: 'Pending',
        
        // Settings
        appearance: 'Appearance',
        theme: 'Theme',
        light: 'Light',
        dark: 'Dark',
        system: 'System',
        journalCustomization: 'Journal Customization',
        
        // Common
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        cancel: 'Cancel',
        confirm: 'Confirm',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        next: 'Next',
        back: 'Back',
        submit: 'Submit',
    },
    es: {
        home: 'Inicio',
        newEntry: 'Nueva Entrada',
        entries: 'Entradas',
        insights: 'Análisis',
        reminders: 'Recordatorios',
        partners: 'Compañeros',
        resources: 'Recursos',
        settings: 'Ajustes',
        upgrade: 'Mejorar',
        admin: 'Admin',
        more: 'Más',
        signOut: 'Cerrar Sesión',
        signIn: 'Iniciar Sesión',
        createAccount: 'Crear Cuenta',
        email: 'Correo',
        password: 'Contraseña',
        name: 'Nombre',
        birthday: 'Cumpleaños',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        preferNotToSay: 'Prefiero no decir',
        language: 'Idioma Preferido',
        selectLanguage: 'Seleccionar idioma...',
        alreadyHaveAccount: '¿Ya tienes cuenta?',
        dontHaveAccount: '¿No tienes cuenta?',
        receiveEmails: 'Recibir recordatorios y consejos por correo',
        welcomeBack: 'Bienvenido de nuevo',
        howAreYouFeeling: '¿Cómo te sientes hoy?',
        yourMoodStreak: 'Tu racha de ánimo',
        days: 'días',
        recentEntries: 'Entradas Recientes',
        viewAll: 'Ver Todo',
        noEntriesYet: 'Sin entradas aún',
        startJourney: 'Comienza tu viaje de diario',
        createNewEntry: 'Crear Nueva Entrada',
        moodRating: 'Calificación de Ánimo',
        selectEmoji: 'Selecciona un emoji',
        whatSongMatchesMood: '¿Qué canción refleja tu ánimo?',
        writeYourThoughts: 'Escribe tus pensamientos...',
        save: 'Guardar',
        saving: 'Guardando...',
        accountabilityPartners: 'Compañeros de Responsabilidad',
        invitePartner: 'Invitar Compañero',
        sendMoodReport: 'Enviar Informe',
        partnerEmail: 'Correo del Compañero',
        personalMessage: 'Mensaje Personal (opcional)',
        sendInvitation: 'Enviar Invitación',
        myPartners: 'Mis Compañeros',
        noPartnersYet: 'Sin compañeros aún',
        connected: 'Conectado',
        pending: 'Pendiente',
        appearance: 'Apariencia',
        theme: 'Tema',
        light: 'Claro',
        dark: 'Oscuro',
        system: 'Sistema',
        journalCustomization: 'Personalización del Diario',
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        delete: 'Eliminar',
        edit: 'Editar',
        close: 'Cerrar',
        next: 'Siguiente',
        back: 'Atrás',
        submit: 'Enviar',
    },
    fr: {
        home: 'Accueil',
        newEntry: 'Nouvelle Entrée',
        entries: 'Entrées',
        insights: 'Analyses',
        reminders: 'Rappels',
        partners: 'Partenaires',
        resources: 'Ressources',
        settings: 'Paramètres',
        upgrade: 'Améliorer',
        admin: 'Admin',
        more: 'Plus',
        signOut: 'Déconnexion',
        signIn: 'Connexion',
        createAccount: 'Créer un Compte',
        email: 'E-mail',
        password: 'Mot de passe',
        name: 'Nom',
        birthday: 'Anniversaire',
        gender: 'Genre',
        male: 'Homme',
        female: 'Femme',
        preferNotToSay: 'Préfère ne pas dire',
        language: 'Langue Préférée',
        selectLanguage: 'Choisir la langue...',
        welcomeBack: 'Bon retour',
        howAreYouFeeling: 'Comment vous sentez-vous?',
        days: 'jours',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        loading: 'Chargement...',
        cancel: 'Annuler',
        close: 'Fermer',
        next: 'Suivant',
        back: 'Retour',
    },
    de: {
        home: 'Startseite',
        newEntry: 'Neuer Eintrag',
        entries: 'Einträge',
        insights: 'Einblicke',
        reminders: 'Erinnerungen',
        partners: 'Partner',
        resources: 'Ressourcen',
        settings: 'Einstellungen',
        upgrade: 'Upgrade',
        signOut: 'Abmelden',
        signIn: 'Anmelden',
        createAccount: 'Konto erstellen',
        email: 'E-Mail',
        password: 'Passwort',
        name: 'Name',
        language: 'Bevorzugte Sprache',
        save: 'Speichern',
        loading: 'Laden...',
        cancel: 'Abbrechen',
        close: 'Schließen',
    },
    pt: {
        home: 'Início',
        newEntry: 'Nova Entrada',
        entries: 'Entradas',
        insights: 'Insights',
        reminders: 'Lembretes',
        partners: 'Parceiros',
        resources: 'Recursos',
        settings: 'Configurações',
        signOut: 'Sair',
        signIn: 'Entrar',
        createAccount: 'Criar Conta',
        email: 'E-mail',
        password: 'Senha',
        name: 'Nome',
        language: 'Idioma Preferido',
        save: 'Salvar',
        loading: 'Carregando...',
        cancel: 'Cancelar',
    },
    ja: {
        home: 'ホーム',
        newEntry: '新規エントリー',
        entries: 'エントリー',
        insights: 'インサイト',
        settings: '設定',
        signOut: 'ログアウト',
        signIn: 'ログイン',
        createAccount: 'アカウント作成',
        save: '保存',
        loading: '読み込み中...',
    },
    ko: {
        home: '홈',
        newEntry: '새 항목',
        entries: '항목',
        insights: '인사이트',
        settings: '설정',
        signOut: '로그아웃',
        signIn: '로그인',
        createAccount: '계정 만들기',
        save: '저장',
        loading: '로딩 중...',
    },
    zh: {
        home: '首页',
        newEntry: '新条目',
        entries: '条目',
        insights: '洞察',
        settings: '设置',
        signOut: '退出',
        signIn: '登录',
        createAccount: '创建账户',
        save: '保存',
        loading: '加载中...',
    },
    ar: {
        home: 'الرئيسية',
        newEntry: 'إدخال جديد',
        entries: 'الإدخالات',
        insights: 'رؤى',
        settings: 'الإعدادات',
        signOut: 'تسجيل الخروج',
        signIn: 'تسجيل الدخول',
        createAccount: 'إنشاء حساب',
        save: 'حفظ',
        loading: 'جاري التحميل...',
    },
    hi: {
        home: 'होम',
        newEntry: 'नई प्रविष्टि',
        entries: 'प्रविष्टियाँ',
        insights: 'अंतर्दृष्टि',
        settings: 'सेटिंग्स',
        signOut: 'लॉग आउट',
        signIn: 'लॉग इन',
        createAccount: 'खाता बनाएं',
        save: 'सहेजें',
        loading: 'लोड हो रहा है...',
    },
    ru: {
        home: 'Главная',
        newEntry: 'Новая запись',
        entries: 'Записи',
        insights: 'Аналитика',
        settings: 'Настройки',
        signOut: 'Выйти',
        signIn: 'Войти',
        createAccount: 'Создать аккаунт',
        save: 'Сохранить',
        loading: 'Загрузка...',
    },
    it: {
        home: 'Home',
        newEntry: 'Nuova Voce',
        entries: 'Voci',
        insights: 'Approfondimenti',
        settings: 'Impostazioni',
        signOut: 'Esci',
        signIn: 'Accedi',
        createAccount: 'Crea Account',
        save: 'Salva',
        loading: 'Caricamento...',
    },
};

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Try to get from localStorage, then browser language, default to 'en'
        const saved = localStorage.getItem('moodtrack_language');
        if (saved && translations[saved]) return saved;
        
        const browserLang = navigator.language?.split('-')[0];
        if (browserLang && translations[browserLang]) return browserLang;
        
        return 'en';
    });

    useEffect(() => {
        localStorage.setItem('moodtrack_language', language);
        // Set document direction for RTL languages
        document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    }, [language]);

    // Translation function
    const t = (key) => {
        return translations[language]?.[key] || translations['en']?.[key] || key;
    };

    const value = {
        language,
        setLanguage,
        t,
        languages: LANGUAGES,
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageContext;
